import { accountIcons } from "@/components/account-switcher-icons"

export const accounts = [
  {
    label: "Admin",
    email: "admin",
    icon: accountIcons.user,
  },
  {
    label: "Admin",
    email: "admin",
    icon: accountIcons.bot,
  },
  {
    label: "Admin",
    email: "admin",
    icon: accountIcons.settings,
  },
]
